const METERS_TO_FEET_DIVISIOR = 0.304799999536704
export default METERS_TO_FEET_DIVISIOR